import type { AuthenticationStrategy } from "@/vendors/authentication/authentication-strategy.types"
import { fetchKeyCloakUser } from "@/vendors/authentication/providers/keycloak/actions/fetch-keycloak-user"

export const keycloakConfiguration: AuthenticationStrategy.Configuration = {
  hasDoubleOptIn: false,
  hasInternalProfilePages: true,
  isPasswordRequired: true,
}

export const keycloakStrategy: AuthenticationStrategy = {
  configuration: keycloakConfiguration,
  fetchUser: fetchKeyCloakUser,
  type: "keycloak",
  urls: {
    createLogin: ({ redirect }) => {
      return `/auth/login${redirect ? `?redirectTo=${encodeURIComponent(redirect)}` : ""}`
    },
    createLogout: ({ redirect }) => {
      return `/auth/logout${redirect ? `?url=${encodeURIComponent(redirect)}` : ""}`
    },
    createLogoutToLogin: ({ providerUrl, redirect, absoluteDomainName }) => {
      const loginUrl = `${absoluteDomainName}/auth/login?redirectTo=${encodeURIComponent(redirect)}`
      const logoutUrl = `${absoluteDomainName}/auth/logout?url=${encodeURIComponent(loginUrl)}`

      return `${providerUrl}/logout?redirect_uri=${encodeURIComponent(logoutUrl)}`
    },
    createProfile: ({ redirect }) => {
      return `/profile/create${redirect ? `?redirectUrl=${encodeURIComponent(redirect)}` : ""}`
    },
    createTrial: ({ redirect }) => {
      return `/profile/create/trial${redirect ? `?redirectUrl=${encodeURIComponent(redirect)}` : ""}`
    },
    manageAccount: (siteModel) => siteModel.urls.myAccount,
  },
}
